'use client';
import { Accordion, AccordionItem } from '@heroui/react';
const FAQAccordion = () => {
  const faqItems = [
    {
      category: 'General Questions',
      items: [
        {
          question: 'What is PayStop?',
          answer:
            'PayStop is a digital financial service platform that enables local businesses and agents to provide secure and efficient financial services to their customers. These services include deposits, withdrawals, and transfers into digital bank accounts, mobile wallets, and traditional bank accounts.',
        },
        {
          question: 'Who can use PayStop?',
          answer:
            'PayStop is designed for local businesses, entrepreneurs, and individuals who wish to offer or access financial services. Whether you are a small business owner or a customer looking to deposit or withdraw money, PayStop has a solution for you.',
        },
        {
          question: 'How does PayStop work?',
          answer:
            'Local businesses can sign up as PayStop agents and provide services like deposits, withdrawals, and money transfers to their customers. The platform supports multiple transaction types, including transactions into digital bank accounts, mobile wallets, and traditional bank accounts. Our agents are equipped with the PayStop app, which allows them to manage transactions securely and efficiently.',
        },
      ],
    },
    {
      category: 'Agent Registration & Responsibilities',
      items: [
        {
          question: 'How can I become a PayStop agent?',
          answer:
            'To become an agent, you must first sign up on the PayStop platform. After registering, you will need to fund your agent account through a commercial bank. Once funded, you can start inviting sub-agents to join your network and begin offering services like deposits and withdrawals to your customers.',
        },
        {
          question: 'What roles are there within the PayStop agent network?',
          answer:
            "There are three main roles within the PayStop agent network: \n- **Super Agent**: The main agent who manages the account and invites sub-agents and agent admins.\n- **Agent Admin**: A user who helps manage the Super Agent’s account and transactions.\n- **Sub-Agent**: A local entrepreneur or small business that uses the Super Agent's network to provide services to customers.",
        },
        {
          question: 'What are the rewards for becoming an agent?',
          answer:
            'Agents earn rewards for funding their accounts and for transactions processed through their network. These rewards include a percentage of the transaction fees, such as deposit and withdrawal transactions, split between the Super Agent and Sub-Agent.',
        },
      ],
    },
    {
      category: 'Transactions',
      items: [
        {
          question: 'How do deposits and withdrawals work?',
          answer:
            "When a customer wants to deposit or withdraw money, they visit a PayStop agent. For deposits, the customer hands over cash, and the agent's account is debited while the customer's account is credited. For withdrawals, the process is reversed: the customer receives cash from the agent after confirming the transaction on the app.",
        },
        {
          question: 'Can I withdraw or deposit money into any bank account or mobile wallet?',
          answer:
            'Yes, PayStop allows customers to withdraw or deposit money into various digital bank accounts, mobile wallets, and traditional bank accounts, giving customers flexibility in managing their finances.',
        },
        {
          question: 'Is the transaction process secure?',
          answer:
            'Absolutely. PayStop prioritises security, using advanced encryption and multi-factor authentication to ensure that all transactions are safe and secure. Agents and customers are required to authenticate transactions using a secure 6-digit PIN.',
        },
      ],
    },
    {
      category: 'Fees & Charges',
      items: [
        {
          question: 'What are the fees for using PayStop?',
          answer:
            'PayStop charges competitive fees for transactions processed through the platform. These fees are split between the Super Agent and Sub-Agent. Fees are applied when customers deposit or withdraw money, and additional charges may apply for other services like money transfers.',
        },
        {
          question: 'Are there any hidden fees?',
          answer:
            'No, there are no hidden fees. All fees are clearly stated when you process a transaction, and our agents receive detailed breakdowns of charges and rewards.',
        },
      ],
    },
    {
      category: 'Support & Troubleshooting',
      items: [
        {
          question: 'What should I do if I have a problem with my transaction?',
          answer:
            'If you encounter any issues with a transaction, please contact our support team immediately by emailing support@paystop.io or calling our helpline at +237 676962723. Our team is available to assist you during working hours.',
        },
        {
          question: 'How can I get help with using the PayStop app?',
          answer:
            "If you're having trouble using the PayStop app, our customer support team is available to guide you. You can also check the app’s help section for detailed instructions and troubleshooting steps.",
        },
      ],
    },
    {
      category: 'Miscellaneous',
      items: [
        {
          question: 'Is PayStop available in my area?',
          answer:
            'PayStop is expanding rapidly and is available in many regions. To check if PayStop is available in your area, please reach out to us via support@paystop.io or visit our website for the latest updates on our service coverage.',
        },
        {
          question: 'How can I contact PayStop?',
          answer:
            'You can contact us via email at support@paystop.io, call us at +237 676962723, or visit our office at Crystal Finance Commercial Avenue Bamenda, P.O. Box 168 Bamenda Cameroon. We’re always here to help!',
        },
      ],
    },
  ];

  return (
    <>
      <section className="text-center section-md bg-gradient-to-b from-primary/20 to-background/5">
        <div className="container space-y-6 container-max ">
          <h1 className="mb-6 font-bold text-transparent hero-title bg-clip-text bg-gradient-to-l from-primary to-secondary ">
            <span>Frequently Asked Questions (FAQ)</span>
          </h1>
          <p className="max-w-3xl mx-auto leading-relaxed text-foreground/70">
            Welcome to the PayStop FAQ page! Here, you’ll find answers to some of the most commonly
            asked questions about our platform. If you can’t find what you’re looking for, feel free
            to get in touch with us directly!
          </p>
        </div>
      </section>
      <section className="section-md">
        <div className="container space-y-12 container-md">
          {faqItems.map((section, sectionIndex) => (
            <div key={sectionIndex}>
              <h3 className="mb-3 text-xl font-semibold">{section.category}</h3>
              <Accordion variant="shadow">
                {section.items.map((item, index) => (
                  <AccordionItem key={index} title={item.question}>
                    {item.answer}
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default FAQAccordion;
